"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Divider = ({ boxProps, typographyProps, title, titleAlign = 'left', thick = false, orientation = 'horizontal', }) => {
    const classNames = `${thick && 'thick'}`;
    return title ? (react_1.default.createElement(index_1.Box, { ...boxProps },
        react_1.default.createElement(Divider_1.default, { textAlign: titleAlign, role: "presentation", component: "div", className: classNames, orientation: orientation },
            react_1.default.createElement(index_1.Typography, { variant: "caption", color: "textSecondary", ...typographyProps }, title)))) : (react_1.default.createElement(index_1.Box, { ...boxProps },
        react_1.default.createElement(Divider_1.default, { className: classNames, orientation: orientation, sx: {
                borderBottomWidth: thick ? '0.5rem' : undefined,
            } })));
};
exports.default = Divider;
